import React from 'react';
import PropTypes from 'prop-types';

const ExpandIcon = ({ color, size }) => (
  <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="26" y="25.5" width="25" height="25" rx="12.5" transform="rotate(-180 26 25.5)" fill="white" />
    <rect x="26" y="25.5" width="25" height="25" rx="12.5" transform="rotate(-180 26 25.5)" stroke="#E2E8F0" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3328 16.7657C11.0203 16.4533 11.0203 15.9467 11.3328 15.6343L13.9671 13L11.3328 10.3657C11.0203 10.0533 11.0203 9.54673 11.3328 9.23431C11.6452 8.9219 12.1517 8.9219 12.4641 9.23431L15.6641 12.4343C15.9765 12.7467 15.9765 13.2533 15.6641 13.5657L12.4641 16.7657C12.1517 17.0781 11.6452 17.0781 11.3328 16.7657Z" fill="#081021" />
  </svg>
);

ExpandIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

ExpandIcon.defaultProps = {
  color: 'currentColor',
  size: '30px',
};

export default ExpandIcon;
